function productDates() {
  this.init = function () {
    $(".date-selection").on("change", function () {
      const selected = $(this).val();
      const stock = $(this).find(":selected").data("stock");
      const selected_text = $(this).find(":selected").data("value");

      if (stock == 0) {
        $(".woocommerce-variation-add-to-cart").removeClass("show");
        $(".woocommerce-variation-add-to-cart").addClass("hide");
      } else {
        $(".woocommerce-variation-add-to-cart").removeClass("hide");
        $(".woocommerce-variation-add-to-cart").addClass("show");
      }

      // Description Section
      $(
        ".class-day span, .class-code span, .class-time span, .class-no-class span, .remaining .spots-left, .class-price-holder .price, .instructors .instructor"
      ).each(function () {
        if ($(this).hasClass(selected)) {
          $(this).removeClass("hide");
          $(this).addClass("show");
        } else {
          $(this).removeClass("show");
          $(this).addClass("hide");
        }
      });

      // Change Woo Attribute Selection
      $(".variations_form .variations .avada-select-parent select").each(
        function () {
          $(this).val(selected_text).trigger("change");
        }
      );

      // Hide / Show Instructor
    });
  };
}

export default productDates;
